module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Validar Questionário - \"" + _vm._s(_vm.parkName) + "\" - " + _vm._s(_vm.referenceYear))]), _vm._v(" "), (this.questionsByAxis) ? _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('tabs', {
    staticClass: "nav-tabs-custom",
    attrs: {
      "value": this.activeAxis
    },
    on: {
      "active": _vm.setActiveAxis
    }
  }, _vm._l((Object.keys(this.questionsByAxis)), function(axis, index) {
    return _c('tab', {
      key: index,
      attrs: {
        "header": _vm.axisHeader(axis)
      }
    }, _vm._l((_vm.questionsByAxis[axis]), function(q) {
      return (_vm.quiz && q.isVisible) ? _c(_vm.getQuestionComponent(q), {
        key: q.uuid,
        ref: "questions",
        refInFor: true,
        tag: "component",
        attrs: {
          "question": q,
          "isDisabled": true,
          "answer": _vm.getQuestionAnswer(q)
        }
      }) : _vm._e()
    }), 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "footer-btns"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v("  Voltar\n                ")]), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "btn btn-sm btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.disapproveCurrentAxis()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v("  Reprovar Eixo\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.approveCurrentAxis()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("  Aprovar Eixo\n                  ")])]), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "button",
      "disabled": !_vm.isAbleToDisapproveQuiz,
      "data-toggle": "modal",
      "data-target": "#disapproval-modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v("  Reprovar Questionário\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.isAbleToApproveQuiz,
      "data-toggle": "modal",
      "data-target": "#approval-modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v("  Aprovar Questionário\n                  ")])])])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "disapproval-modal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Reprovar Questionário")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Ao clicar em \"Ok\" o questionário será reprovado e devolvido ao parque tecnológico. Deseja continuar?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.disapproveQuiz()
      }
    }
  }, [_vm._v("Ok")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "approval-modal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Aprovar Questionário")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Ao clicar em \"Ok\" o questionário será aprovado e finalizado. Deseja continuar?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.approveQuiz()
      }
    }
  }, [_vm._v("Ok")])])])])]), _vm._v(" "), _c('notifier', {
    ref: "notifier"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31e72306","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/quizzes/ParkQuizValidation.vue
// module id = 712
// module chunks = 1